/**
 * Format a Date object or date string to YYYY-MM-DD format.
 */
export const formatDateYMD = (date: Date | string | number): string => {
  const d = date instanceof Date ? date : new Date(date);
  const year = d.getFullYear();
  const month = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};
